import styled from 'styled-components';
import Lottie from 'lottie-react';
import Typography from '../typography/Typography';
import { GoogleAuthIcon } from '../assets';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
`;
export const LottieWrapper = styled.div `
  width: 10rem;
  position: relative;
  left: ${({ isTwoFaGoogle }) => (isTwoFaGoogle ? 'unset' : '-1.6rem')};
`;
export const AnimationAndTextWrapper = styled.div `
  display: flex;
  flex-direction: ${({ isEmailTwoFa }) => (isEmailTwoFa ? 'row' : 'column')};
  gap: 0.5rem;
  padding-top: 1.5rem;
`;
export const InputsContainer = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.5rem;
  margin: 0.8rem 0
    ${({ hasErrorMessage }) => (hasErrorMessage ? '1.4rem' : '1.8rem')};
`;
export const CustomGoogleAuthIcon = styled(GoogleAuthIcon) `
  height: 7.6rem;
  width: 6.8rem;
`;
export const Header = styled.header `
  display: flex;
  justify-content: center;
  position: relative;
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.borders.default};
  padding: 1.7rem 2.4rem;
`;
export const IconWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 3.2rem;
  height: 3.2rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.borders.default};
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  position: absolute;
  right: 2.4rem;
`;
export const DisaclaimerWrapper = styled.div `
  display: flex;
  align-items: center;
  gap: 2rem;
  padding: 1.2rem 1.2rem 1.2rem 2.1rem;
  margin-bottom: 2.4rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.borders.default};
  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
`;
export const LoadingLottieWrapper = styled.div `
  z-index: ${({ theme }) => theme.zIndex.highest};
  position: absolute;
  height: 10.6rem;
  width: 10.6rem;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;
export const Blur = styled.div `
  z-index: ${({ theme }) => theme.zIndex.high};
  backdrop-filter: blur(6px);
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;
export const CheckSpamWrapper = styled.div `
  padding: 0.8rem 1.2rem;
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
  border-radius: ${({ theme }) => theme.borderRadius.high};
  margin: 0 0 0.8rem 0;

  ${({ theme }) => theme.media.mobileM `
    padding: 1.6rem 1.2rem;
  `};

  ${({ theme }) => theme.media.tablet `
    padding: 1.6rem 1.2rem;
    margin: 1.2rem 0 2rem 0;
  `};
`;
export const CustomLottie = styled(Lottie) `
  width: 10rem;
`;
export const CustomTypography = styled(Typography) `
  width: 100%;
  max-width: 40rem;
  ${({ theme }) => theme.media.tablet `
  width: unset;
`};
`;
export const EmailTypography = styled(Typography) `
  word-wrap: break-word;
`;
//# sourceMappingURL=styles.js.map